import { useUserProfile } from "../../hooks/useUserProfile";
import TelegramRegistration, { useIsTelegramRegistrationValid} from "./profilePages/TelegramRegistration";
import { useMemo, useState } from "react";
import SearchPreferences from "./profilePages/SearchPreferences";
import SubscriptionManagement, { useIsSubscriptionManagementValid } from "./profilePages/SubscriptionManagement";
import { Breadcrumbs, Button, Menu } from "react-daisyui";
import { useSearchParams } from 'react-router-dom';
import PageLayout from "./components/PageLayout";
import ImportantFactors from "./profilePages/ImportantFactors";
import { useNavigate } from 'react-router-dom';
import routes from "../../modules/routes/Routes";
import FeedbackDialog from "./components/FeedbackDialog";
import { useAuth } from "../../modules/authentication/AuthProvider";
import { useTranslation } from 'react-i18next';
import { ProfilePageValidationProvider, useProfilePageValidation } from "./components/ProfilePageValidationContext";

const GettingStarted: React.FC = () => {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const { userProfile, localProfile, updateUserProfile } = useUserProfile();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    // Comment out ImportantFactors page
    // const [currentPage, setCurrentPage] = useState<'SearchPreferences' | 'ImportantFactors'>('SearchPreferences');
    const [currentPage, setCurrentPage] = useState<'SearchPreferences'>('SearchPreferences');
    const { isPageValidated } = useProfilePageValidation();

    const isCurrentPageValid = isPageValidated(currentPage);

    if (userProfile === undefined || localProfile === undefined) {
        return null; // or return a loading indicator
    }

    const finishOnboarding = async () => {
        try {
            await updateUserProfile({ ...localProfile, is_onboarding_complete: true });
            navigate(routes.app.matches.build());
        } catch (error) {
            console.error('Error finishing onboarding:', error);
            // Optionally, you can add error handling here, such as displaying an error message to the user
        }
    };

    const navigateNextPage = async () => {
        // if (currentPage === 'SearchPreferences') setCurrentPage('ImportantFactors');
        // else if (currentPage === 'ImportantFactors') await finishOnboarding();
        if (currentPage === 'SearchPreferences') await finishOnboarding();
    };

    const navigatePreviousPage = async () => {
        // if (currentPage === 'ImportantFactors') setCurrentPage('SearchPreferences');
        // No-op, since there's only one page
    };

    const renderPage = () => {
        switch (currentPage) {
            case 'SearchPreferences':
                return <SearchPreferences />;
            // case 'ImportantFactors':
            //     return <ImportantFactors />;
        }
    };

    const navbarCenter = (
        <Breadcrumbs className="text-sm">
            <Breadcrumbs.Item className={`font-medium ${currentPage === 'SearchPreferences' ? 'text-primary' : ''}`}>{t('pages.gettingStarted.breadcrumbs.searchPreferences')}</Breadcrumbs.Item>
            {/* <Breadcrumbs.Item className={`font-medium ${currentPage === 'ImportantFactors' ? 'text-primary' : ''}`}>{t('pages.gettingStarted.breadcrumbs.importantFactors')}</Breadcrumbs.Item> */}
        </Breadcrumbs>
    );

    const drawerMenuItems = (
        <>
            <Menu.Item className={`font-medium ${currentPage === 'SearchPreferences' ? 'text-primary' : ''}`}>{t('pages.gettingStarted.breadcrumbs.searchPreferences')}</Menu.Item>
            {/* <Menu.Item className={`font-medium ${currentPage === 'ImportantFactors' ? 'text-primary' : ''}`}>{t('pages.gettingStarted.breadcrumbs.importantFactors')}</Menu.Item> */}
        </>
    );

    const navbarEnd = (
        <div className="flex justify-end">
            <FeedbackDialog currentPage={currentPage} />
            <Button color="ghost" size="sm" onClick={logout} className="ml-2">
                {t('pages.gettingStarted.logout')}
            </Button>
        </div>
    );

    const handleNext = async () => {
        await updateUserProfile(localProfile);
        await navigateNextPage();
    };

    const handlePrevious = async () => {
        updateUserProfile(localProfile);
        await navigatePreviousPage();
    };

    return (
        <PageLayout
            navbarCenter={navbarCenter}
            navbarEnd={navbarEnd}
            drawerMenuItems={drawerMenuItems}
            currentPage={currentPage}
            ignorePageMargin={true}
        >
            <div className="mx-auto max-w-[500px] px-4">
                <div className="flex flex-col gap-4 min-h-screen">
                    <div className="flex flex-col gap-4 mt-24 flex-grow">
                        {renderPage()}
                    </div>

                    <div className="flex flex-col gap-2 w-full self-end mb-8">
                        <Button
                            key={`next+${currentPage}`}
                            color="primary"
                            onClick={handleNext}
                            className="w-full"
                            data-umami-event={`Onboarding Next-button ${currentPage}`}
                            data-testid="onboarding-next-button"
                            disabled={!isCurrentPageValid}
                        >
                            {t('pages.gettingStarted.nextButton')}
                        </Button>
                        {/* {currentPage !== 'SearchPreferences' && (
                            <Button key={`back+${currentPage}`} color="ghost" onClick={handlePrevious} className="w-full" data-umami-event={`Onboarding Back-button ${currentPage}`}>
                                {t('pages.gettingStarted.backButton')}
                            </Button>
                        )} */}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

const GettingStartedWithValidation = () => {
    return (
        <ProfilePageValidationProvider>
            <GettingStarted />
        </ProfilePageValidationProvider>
    );
}

export default GettingStartedWithValidation;
